<form class="support-composer" (submit)="$event.preventDefault(); submit()" (paste)="onPaste($event)" novalidate>
  <support-rich-text
    [(value)]="text"
    [placeholder]="placeholder() ?? ('support.detail.replyPlaceholder' | transloco)"
    [disabled]="busy()"
    data-test-id="support-detail-reply"
  >
    <ng-container richTextToolbarExtra>
      <span class="support-composer-toolbar-spacer"></span>
      <button
        type="button"
        class="support-composer-tool"
        [disabled]="attachmentsFull() || pasting() || busy()"
        [attr.aria-label]="(viewport.isTouchPrimary() ? 'support.form.attachments.pasteButtonTouch' : 'support.form.attachments.pasteButton') | transloco"
        [title]="(viewport.isTouchPrimary() ? 'support.form.attachments.pasteButtonTouch' : 'support.form.attachments.pasteButton') | transloco"
        (click)="pasteFromClipboard()"
        data-test-id="support-composer-paste"
      >
        <i eIcon icon="paste"></i>
      </button>
      <button
        type="button"
        class="support-composer-tool"
        [disabled]="attachmentsFull() || busy()"
        [attr.aria-label]="'support.form.attachments.upload' | transloco"
        [title]="'support.form.attachments.upload' | transloco"
        (click)="chooseFile()"
        data-test-id="support-composer-upload"
      >
        <i eIcon icon="upload"></i>
      </button>
      @if (screenshot() !== 'off' && !viewport.isPhone()) {
        <button
          type="button"
          class="support-composer-tool"
          [disabled]="attachmentsFull() || capturing() || busy()"
          [attr.aria-label]="'support.form.attachments.capture' | transloco"
          [title]="'support.form.attachments.capture' | transloco"
          (click)="capture()"
          data-test-id="support-composer-capture"
        >
          <i eIcon icon="camera"></i>
        </button>
      }
      <!-- accept="image/*": mobiele browsers bieden dan camera + fotobibliotheek; de normalisatie maakt er toch jpeg van. -->
      <input #composerFile type="file" accept="image/*" hidden (change)="onFileChosen($event)" data-test-id="support-composer-file-input" />
    </ng-container>
  </support-rich-text>

  @if (drafts().length > 0) {
    <div class="support-composer-thumbs">
      @for (item of drafts(); track item.id) {
        <div class="support-composer-thumb" data-test-id="support-composer-attachment">
          <img [src]="item.previewUrl" [alt]="item.fileName" />
          <button
            type="button"
            class="support-composer-thumb-remove"
            [attr.aria-label]="'support.form.attachments.remove' | transloco"
            [title]="'support.form.attachments.remove' | transloco"
            (click)="removeAttachment(item.id)"
            data-test-id="support-composer-attachment-remove"
          >
            <i eIcon icon="xmark"></i>
          </button>
        </div>
      }
    </div>
  }
  @if (attachmentsFull()) {
    <span class="support-composer-help">
      {{ (attachmentsDisabled() ? 'support.form.attachments.ticketFull' : 'support.form.attachments.max') | transloco }}
    </span>
  }

  @if (!hideSend()) {
    <div class="support-composer-actions">
      <button eBtn size="sm" type="submit" color="primary" [icon]="sendIcon()" [disabled]="!canSend()" [loading]="busy()" data-test-id="support-detail-send">
        {{ sendLabel() ?? ('support.detail.send' | transloco) }}
      </button>
    </div>
  }
</form>

<!-- Beeldeditor na een screenshot: in een dialoog (boven het support-paneel en
     de notitiepanelen), want die zijn te smal om comfortabel te bewerken. -->
@if (screenshot() !== 'off') {
  <e-dialog
    [open]="editorSource() !== undefined"
    (openChange)="$event || closeEditor()"
    [title]="'support.editor.title' | transloco"
    [restoreFocus]="false"
    size="sxl"
  >
    <ng-template>
      @if (editorSource(); as source) {
        <support-image-editor [source]="source" (confirmed)="onEdited($event)" (cancelled)="closeEditor()" />
      }
    </ng-template>
  </e-dialog>
}
